import React from "react";
import Skeleton from "react-loading-skeleton";

export default function SkeletonCard() {
    return (
        <div className="w-[41vw] mb-3 md:mb-5 pb-2 rounded-xl md:flex bg-gray-100 text-black">
            <div className="w-full h-[200px] md:w-[40%] md:max-h-[150px] md:ml-1 md:mt-1 lg:ml-2 lg:mt-2">
                <Skeleton height="100%" width="100%" />
            </div>
            <div className="md:flex-col md:items-center w-full p-2">
                <Skeleton height="2rem" width="50%" />
                <Skeleton height="1.75rem" width="90%" />
                <Skeleton height="1.75rem" width="30%" />
            </div>
        </div>
    )
}